import React from 'react'

import { P } from 'ui/bend'

const Grace = () => (
  <P color='primary' textAlign='center'>
    We are updating your account. Please check back later.
  </P>
)

export default Grace
